import React, { Suspense } from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import './App.css';

// Lazy load the pages
const MainPage = React.lazy(() => import('./pages/MainPage'));
const AboutPage = React.lazy(() => import('./pages/AboutPage'));
const ResourcesPage = React.lazy(() => import('./pages/ResourcesPage'));
const ProductPage = React.lazy(() => import('./pages/ProductPage'));

const LoadingSpinner = () => (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh',backgroundColor: '#05070A' }}>
      <p></p>
    </div>
);

const router = createBrowserRouter([
  {
    path: '/',
    element: (
        <Suspense fallback={<LoadingSpinner />}>
          <MainPage />
        </Suspense>
    ),
  },
  {
    path: '/about',
    element: (
        <Suspense fallback={<LoadingSpinner />}>
          <AboutPage />
        </Suspense>
    ),
  },
  {
    path: '/resources',
    element: (
        <Suspense fallback={<LoadingSpinner />}>
          <ResourcesPage />
        </Suspense>
    ),
  },
    {
        path: '/product',
        element: (
            <Suspense fallback={<LoadingSpinner />}>
                <ProductPage />
            </Suspense>
        ),
    }
]);



function App() {
  return <RouterProvider router={router} />;
}

export default App;